import { useState, useEffect, Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import PaymentMethods from '../checkout/PaymentMethods'
import API from 'api'
import CreditCardDetails from '../account/payments/CreditCardDetails'
import { isLoggedIn } from '../../utils'

const AddNewCardBtn = ({ onClick, isActive }) => {
  return (
    <div className='add-new-card' onClick={onClick}>
      <i className='font-icons icon-credit-card' />
      <FormattedMessage id='add-new-cc' defaultMessage='Add new card' />
      <i
        className={`font-icons ${
          isActive ? 'top-arrow-icon' : 'bottom-arrow-icon'
        }`}
      />
    </div>
  )
}
export default function CheckoutPayments({ paymentRef, change, setSelectedMethod, shop, isAdventure }) {
  const [cards, setCards] = useState([])
  const [selectedCard, updateSelectedCards] = useState()
  const [showAddCard, setShowAddCard] = useState(false)
  const isCardsAvailable = !!cards.length
  const sectionTitle = isCardsAvailable ? (
    <FormattedMessage
      id='new_payment_method'
      defaultMessage='New payment method'
    />
  ) : null
  useEffect(() => {
    if(isLoggedIn()) {
      API('account/payment-methods/')
        .get()
        .then((cards) => {
          if(!cards.length) {
            setShowAddCard(true)
          }
          setCards(cards)
        })
        .catch(() => {
          setShowAddCard(true)
        })
    } else {
      setShowAddCard(true)
    }
  }, [])

  const onCreditCardSelect = (objectId, brand) => {
    updateSelectedCards(objectId)
    change('paymentMethodBrand', brand)
  }

  const onAddNewCard = () => {
    setShowAddCard((val) => !val)
    updateSelectedCards(false)
    change('paymentMethodId', null)
    change('paymentMethodBrand', null)
  }

  return (
    <div>
      {isCardsAvailable && (
        <Fragment>
          <div className='saved-cards'>
            {cards.map((card) => (
              <CreditCardDetails
                details={card.card}
                key={card.objectId}
                isCheckout
                selectedCard={selectedCard}
                objectId={card.objectId}
                onCreditCardSelect={onCreditCardSelect}
              />
            ))}
          </div>
          <AddNewCardBtn onClick={onAddNewCard} isActive={showAddCard} />
        </Fragment>
      )}
      {showAddCard && (
        <PaymentMethods
          ref={paymentRef}
          sectionTitle={sectionTitle}
          setSelectedMethod={setSelectedMethod}
          shop={shop}
          isAdventure={isAdventure}
        />
      )}
    </div>
  )
}
